import React, { useEffect, useState } from 'react';
import { addSpace } from '../../components/Tools';
import ApexCharts from 'react-apexcharts';
import axios from 'axios';
import qs from 'qs';

function BilanDynDepGestion(props)
{
    const [series, setSeries] = useState(undefined)
    const [options, setOptions] = useState(undefined)

    useEffect(() => {

        var filename = "Dynamique dépenses " + (props.user.nomen == 'M4' || props.user.nomen == 'M41' || props.user.nomen == 'M43' || props.user.nomen == 'M49'?'d\'exploitation':'de gestion');

        var ComEpci = null;
        if (props.user.id_organisme_type === '1') {
            ComEpci = 'Com';
        }
        else if (props.user.id_organisme_type === '2') {
            ComEpci = 'Epci';
        }
        else if (props.user.id_organisme_type === '3') {
            ComEpci = 'Com';
        }

        /* Initialisation des options avec les années */
        var option_tmp = {
            chart: {
                toolbar: {
                    show: props.download?true:false,
                    export: {
                        svg: {
                          filename: filename.replace("'", '_').replace("/", '_').replace(".", ''),
                        },
                        png: {
                          filename: filename.replace("'", '_').replace("/", '_').replace(".", ''),
                        },
                        csv: {
                          filename: filename.replace("'", '_').replace("/", '_').replace(".", ''),
                        },
                    },
                },
                type: 'line',
                height: 350
            },
            stroke: {
              curve: 'smooth'
            },
            title: {
                text: filename
            },
            xaxis: {
                categories: props.annees
            },
            yaxis: {
                labels: {
                  formatter: function (value) {
                    return addSpace(Math.round(value*100)/100, true);
                  }
                },
            },
        }
        setOptions(option_tmp)

        axios.post('https://app-slfinance.fr/api/graph.php', qs.stringify({
        	'DynDepGestionBase100': true,
            'ComEpci': ComEpci,
            'id_budget': props.user.id_budget,
            'annees': props.annees,
            'hypothese': 'R',
            'ba': props.user.budget_annexe,
            'nomen': props.user.nomen
        }))
        .then(async (res) => {

            var tmp = [];
            if (res.data[0][0] !== 0) {
                tmp.push({
                    name: 'Dépenses ' + (props.user.nomen == 'M4' || props.user.nomen == 'M41' || props.user.nomen == 'M43' || props.user.nomen == 'M49'?'d\'exploitation':'de gestion'),
                    data: res.data[0],
                    color: '#e74c3c',
                })
            }
            if (res.data[1][0] !== 0) {
                tmp.push({
                    name: "Dépenses de personnel",
                    data: res.data[1],
                    color: '#f39c12',
                })
            }
            if (res.data[2][0] !== 0) {
                tmp.push({
                    name: 'Charges à caractère général',
                    data: res.data[2],
                    color: '#2c3e50',
                })
            }

            await setSeries(tmp);
        })
    }, [])


	return (
		<div style={{margin: 5}}>
            {options && series?
			<ApexCharts
                series={series}
                options={options}
                width={'100%'}
                height={props.height?props.height:300}
                type="line"
            />:null}
		</div>
	)
}

export default BilanDynDepGestion;
